/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { EDIT_KNOWLEDGE_CATEGORY } from "./actionTypes"
import { apiError, editKnowledgeCategorySuccess } from "./actions"

//Include Both Helper File with needed methods
import { updateKnowledgeCategory } from "../../../helpers/backend_helper"

function* edit(action) {
  try {
    const response = yield call(updateKnowledgeCategory, action.payload.form)
    yield put(editKnowledgeCategorySuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* knowledgeCategoryEditSaga() {
  yield takeEvery(EDIT_KNOWLEDGE_CATEGORY, edit)
}

export default knowledgeCategoryEditSaga
